module.exports = __webpack_public_path__ + "img/8.2b494cce.png";